import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-418ede90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "timetable" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Maandag", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Dinsdag", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Woensdag", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Donderdag", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Vrijdag", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Zaterdag", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Zondag", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _createElementVNode("td", null, "10:00 " + _toDisplayString($data.separator) + " 20:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_3,
      _createElementVNode("td", null, "10:00 " + _toDisplayString($data.separator) + " 20:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_4,
      _createElementVNode("td", null, "10:00 " + _toDisplayString($data.separator) + " 20:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_5,
      _createElementVNode("td", null, "10:00 " + _toDisplayString($data.separator) + " 20:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_6,
      _createElementVNode("td", null, "10:00 " + _toDisplayString($data.separator) + " 20:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_7,
      _createElementVNode("td", null, "12:00 " + _toDisplayString($data.separator) + " 18:00", 1)
    ]),
    _createElementVNode("tr", null, [
      _hoisted_8,
      _createElementVNode("td", null, "12:00 " + _toDisplayString($data.separator) + " 18:00", 1)
    ])
  ], 512))
}